import { Controller } from "@hotwired/stimulus";
import Tribute from "tributejs";
import Trix from "trix";

export default class extends Controller {
  initialize () {
    this.fetchUsers = this.fetchUsers.bind(this);
    this.replaced = this.replaced.bind(this);
  }

  connect () {
    this.editor = this.element.editor;
    this.initializeTribute();
  }

  disconnect () {
    this.latestRequest = null;
    this.element.removeEventListener("tribute-replaced", this.replaced);
    this.tribute.hideMenu();
    this.tribute.detach(this.element);
  }

  initializeTribute () {
    this.tribute = new Tribute({
      trigger: "@",
      allowSpaces: true,
      lookup: "full_name",
      menuItemLimit: 10,
      menuItemTemplate: item => item.original.menu_item,
      noMatchTemplate: "",
      selectTemplate: item => item?.original ? "" : null,
      values: this.fetchUsers,
    });
    const tribute = this.tribute;
    const selectItemAtIndex = tribute.selectItemAtIndex.bind(tribute);
    // Tribute queues keyboard selections, which can outlive the menu or editor.
    tribute.selectItemAtIndex = (index, event) => {
      if (!tribute.isActive || !tribute.current.filteredItems) return;
      selectItemAtIndex(index, event);
    };
    this.tribute.attach(this.element);
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this);
    this.element.addEventListener("tribute-replaced", this.replaced);
  }

  fetchUsers (text, callback) {
    const request = Symbol("user-mention-request");
    this.latestRequest = request;
    const respond = users => {
      if (this.latestRequest !== request) return;
      callback(Array.isArray(users) ? users : []);
    };
    this.tribute.current.filteredItems = null;
    this.tribute.menu.querySelector("ul").innerHTML = "";
    fetch(`/admin/user_mentions.json?query=${encodeURIComponent(text)}`)
      .then(response => response.ok ? response.json() : [])
      .then(respond)
      .catch(_error => respond([]));
  }

  replaced (e) {
    const mention = e.detail?.item?.original;
    if (!mention) return;
    const attachment = new Trix.Attachment({
      sgid: mention.sgid,
      content: mention.content,
      caption: mention.slack_mention,
    });
    this.editor.insertAttachment(attachment);
    this.editor.insertString(" ");
  }

  _pasteHtml (html, startPos, endPos) {
    const position = this.editor.getPosition();
    this.editor.setSelectedRange([position - (endPos - startPos), position]);
    this.editor.deleteInDirection("backward");
  }
}
